var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 0.529785C1.85218 0.529785 1.47064 0.688006 1.18934 0.969642C0.908035 1.25128 0.75 1.63326 0.75 2.03155C0.75 2.42984 0.908035 2.81182 1.18934 3.09345C1.47064 3.37509 1.85218 3.53331 2.25 3.53331H27.75C28.1478 3.53331 28.5294 3.37509 28.8107 3.09345C29.092 2.81182 29.25 2.42984 29.25 2.03155C29.25 1.63326 29.092 1.25128 28.8107 0.969642C28.5294 0.688006 28.1478 0.529785 27.75 0.529785H2.25ZM0.75 11.0421C0.75 10.6438 0.908035 10.2619 1.18934 9.98022C1.47064 9.69858 1.85218 9.54036 2.25 9.54036H27.75C28.1478 9.54036 28.5294 9.69858 28.8107 9.98022C29.092 10.2619 29.25 10.6438 29.25 11.0421C29.25 11.4404 29.092 11.8224 28.8107 12.104C28.5294 12.3857 28.1478 12.5439 27.75 12.5439H2.25C1.85218 12.5439 1.47064 12.3857 1.18934 12.104C0.908035 11.8224 0.75 11.4404 0.75 11.0421ZM0.75 20.0542C0.75 19.6559 0.908035 19.2739 1.18934 18.9923C1.47064 18.7107 1.85218 18.5524 2.25 18.5524H27.75C28.1478 18.5524 28.5294 18.7107 28.8107 18.9923C29.092 19.2739 29.25 19.6559 29.25 20.0542C29.25 20.4525 29.092 20.8345 28.8107 21.1161C28.5294 21.3977 28.1478 21.556 27.75 21.556H2.25C1.85218 21.556 1.47064 21.3977 1.18934 21.1161C0.908035 20.8345 0.75 20.4525 0.75 20.0542Z",
    fill: "#023543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.15ec99b78b3974e98034565fcbe09d21.svg";
export { ForwardRef as ReactComponent };